export default __webpack_public_path__ + "images/67458de8e6741635f6e4010ff80fc0c5.gif";